@use 'sass:map';
@use '../../variables' as *;
@use 'common/assets/scss/global' as *;
@import '@fortawesome/fontawesome-svg-core/styles.css';

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

.search-container {
  width: 100%;
  padding: 16px;
  margin-right: auto;
  margin-left: auto;
  max-width: 600px + 2 * 16;

  @media (width >= map.get($grid-breakpoints, lg)) {
    display: flex;
    justify-content: center;
    width: unset;
    padding: unset;
    margin-right: 32px;
    margin-left: 32px;
    max-width: unset;
  }
}

.search {
  flex: 0 1 434px;
  position: relative;
  transition: flex-basis 0.15s ease-out;

  &:hover,
  &:has(:focus-visible, input:not(:placeholder-shown)) {
    flex-basis: 600px;
  }

  &-field {
    display: flex;
    align-items: center;
    border-radius: 50px;
    background-color: var(--#{$prefix}basic-grey);
    outline: 1px solid var(--#{$prefix}stroke);

    > .start {
      display: inline-flex;
      margin-left: 12px;
      opacity: 0.7;

      > svg {
        font-size: 16px;
      }
    }

    > .middle {
      flex: 1 1 0;
      margin-inline: 8px;

      > input {
        width: 100%;
        padding-top: 8.5px;
        padding-bottom: 8.5px;
        outline: unset;
        font-size: var(--#{$prefix}font-size-md);
        color: inherit;
      }
    }

    > .end {
      display: inline-flex;
      margin-right: 12px;
      opacity: 0.7;

      > button {
        display: inline-flex;
        margin-right: -12px;
        margin-left: -8px;

        > svg {
          font-size: 16px;
        }
      }
    }

    &:hover,
    &:has(input:focus-visible) {
      outline: 2px solid var(--#{$prefix}primary);
      box-shadow: var(--#{$prefix}shadow-hover) HEXToRGBA(var(--#{$prefix}primary), 0.2);

      > .start > svg {
        color: var(--#{$prefix}primary);
      }
    }
  }

  &-results {
    position: absolute;
    top: calc(100% + 8px);
    width: 100%;
    background-color: var(--#{$prefix}body-bg);
    padding: 16px;
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    border-radius: 8px;
    box-shadow: var(--#{$prefix}shadow-neutral) HEXToRGBA($black, 0.1);
    max-height: calc(100dvh - #{calc(#{$header-height + 2 * 16 + 2 * (8.5 + 16) + 5} + var(--recia-font-size-md))});
    overflow-y: auto;

    > ul {
      @include unstyled-list;

      > li {
        > .header {
          color: var(--#{$prefix}basic-black-lighter);
          display: block;
          font-weight: 500;
          font-style: italic;
          border-bottom: 1px solid var(--#{$prefix}stroke);
          margin-bottom: 8px;
          padding: 4px 10px;
        }

        > ul {
          @include unstyled-list;
          display: flex;
          flex-direction: column;
          row-gap: 8px;

          > li {
            > a {
              @include unstyled-link;
              display: inline-block;
              width: 100%;
              background-color: #f8f8f8;
              border-radius: 4px;
              outline: none;

              > div {
                margin: 8px 10px;
                overflow: hidden;

                > .header {
                  display: flex;
                  align-items: center;
                  gap: 4px;
                  margin-bottom: 4px;

                  > .result-title {
                    font-family: $sora;
                    font-size: var(--#{$prefix}font-size-sm);
                    line-height: 140%;
                  }

                  > .result-tag {
                    display: inline-flex;
                    font-family: $dm-sans;
                    font-size: var(--#{$prefix}font-size-xs);
                    font-weight: 500;
                    padding: 4px 10px;
                    border-radius: 13px;
                    background-color: var(--#{$prefix}stroke);

                    @each $type, $values in $categories {
                      &.#{$type} {
                        background-color: var(--#{$prefix}#{$type});
                        color: var(--#{$prefix}#{$type}-text);
                      }
                    }
                  }
                }

                > span {
                  line-height: 150%;
                }
              }

              &:hover,
              &:focus-visible {
                background-color: #f0f0f0;

                > div > .header > .result-title {
                  color: var(--#{$prefix}primary);
                  font-weight: 600;
                }
              }
            }

            &.skeleton {
              padding: 8px 10px;
              height: 4em;
              border-radius: 4px;
              background: linear-gradient(90deg, #e9e9e9 30%, #f6f6f6 50%, #e9e9e9 70%);
              background-size: 200% 100%;
              animation: shimmer 1.5s infinite linear;
            }
          }
        }
      }
    }

    > .empty {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100px;
    }

    &:focus-visible {
      outline: 2px dotted var(--#{$prefix}primary);
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    &-field {
      > .start {
        margin-left: 18px;
      }

      > .middle {
        margin-inline: 16px;

        > input {
          padding-top: 11px;
          padding-bottom: 11px;
        }
      }

      > .end {
        margin-right: 18px;
      }
    }
  }

  @media (width >= map.get($grid-breakpoints, lg)) {
    &-results {
      max-height: calc(100dvh - ($header-height + 2 * 16px));
      width: 600px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
